import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import SearchResults from "../types/searchResults";
import SearchParams from "../types/searchParams";
import getSearchQueryString from "../helpers/getSearchQueryString";
import KeyValue from "../types/keyValue";

interface OptionsState {
  statesSearchResults?: SearchResults;
  statesSearchStatus: "idle" | "loading" | "failed";
  jobActionsSearchResults?: SearchResults;
  jobActionsSearchStatus: "idle" | "loading" | "failed";
  answerTypes: KeyValue[];
  answerTypeStatus: "idle" | "loading" | "failed";
  attachmentCopyTypes: KeyValue[];
  attachmentCopyStatus: "idle" | "loading" | "failed";
}

const initialState: OptionsState = {
  statesSearchStatus: "idle",
  jobActionsSearchStatus: "idle",
  answerTypes: [],
  answerTypeStatus: "idle",
  attachmentCopyTypes: [],
  attachmentCopyStatus: "idle",
};

export const searchStates = createAsyncThunk<SearchResults, SearchParams>(
  "options/states/search",
  async (search: SearchParams) => {
    let qs = getSearchQueryString(search);
    const response = await http.get<SearchResults>(
      `/option/search-usastates?${qs}`
    );
    return response.data;
  }
);

export const searchJobActions = createAsyncThunk<SearchResults, SearchParams>(
  "options/jobActions/search",
  async (search: SearchParams) => {
    let qs = getSearchQueryString(search);
    const response = await http.get<SearchResults>(
      `/option/search-jobactions?${qs}`
    );
    return response.data;
  }
);

export const getAnswerTypes = createAsyncThunk<KeyValue[]>(
  "options/answer-types",
  async () => {
    const response = await http.get<KeyValue[]>(`/option/answer-types`);
    return response.data;
  }
);

export const getAttachmentCopyTypes = createAsyncThunk<KeyValue[]>(
  "options/attachment-copy-types",
  async () => {
    const response = await http.get<KeyValue[]>(
      `/option/attachment-copy-types`
    );
    return response.data;
  }
);

const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {
    // exampleReducer(state, action){
    //     state.sample = action.payload
    // }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchStates.pending, (state) => {
        state.statesSearchStatus = "loading";
      })
      .addCase(searchStates.fulfilled, (state, action) => {
        state.statesSearchStatus = "idle";
        state.statesSearchResults = action.payload;
      })
      .addCase(searchStates.rejected, (state) => {
        state.statesSearchStatus = "failed";
      })
      .addCase(searchJobActions.pending, (state) => {
        state.jobActionsSearchStatus = "loading";
      })
      .addCase(searchJobActions.fulfilled, (state, action) => {
        state.jobActionsSearchStatus = "idle";
        state.jobActionsSearchResults = action.payload;
      })
      .addCase(searchJobActions.rejected, (state) => {
        state.jobActionsSearchStatus = "failed";
      })
      .addCase(getAnswerTypes.pending, (state) => {
        state.answerTypeStatus = "loading";
      })
      .addCase(getAnswerTypes.fulfilled, (state, action) => {
        state.answerTypeStatus = "idle";
        state.answerTypes = action.payload;
      })
      .addCase(getAnswerTypes.rejected, (state) => {
        state.answerTypeStatus = "failed";
      })
      .addCase(getAttachmentCopyTypes.pending, (state) => {
        state.attachmentCopyStatus = "loading";
      })
      .addCase(getAttachmentCopyTypes.fulfilled, (state, action) => {
        state.attachmentCopyStatus = "idle";
        state.attachmentCopyTypes = action.payload;
      })
      .addCase(getAttachmentCopyTypes.rejected, (state) => {
        state.attachmentCopyStatus = "failed";
      });
  },
});

export default optionsSlice.reducer;
// export const { exampleReducer } = optionsSlice.actions;
